<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop"><i>It’s like a lion at the door;</i></p>
<p class="first"><i>And when the door begins to crack,</i></p>
<p class="first"><i>It’s like a stick across your back;</i></p>
<p class="first"><i>And when your back begins to smart,</i></p>
<p class="first"><i>It’s like a penknife in your heart…</i></p>
<p style="text-align:right;">(A Nursery Rhyme)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter002.vue?a602b664